import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { observer } from "mobx-react";
import { toDate } from 'core/utils';
import { BaasicButton, BasicCheckbox } from 'core/components';

function PickTicketInfoModalTemplate({ pickTicketInfoModalStore }) {
    const {
        loaderStore: { loading },
        items,
        disabled,
        sendInfoEmail,
        isLoading,
        setIncludeInPickTicket,
        refreshPickTicket,
        refreshPickTicketNewFlow,
        isChanged,
        groupedSentSeparatelyItems,
        sentSeparatelyItems,
        isOrderSent,
        disabledSendOrder
    } = pickTicketInfoModalStore;
    return (
        <div style={{ minHeight: 80 }}>
            <Content loading={loading}>
                <div className="modal__header">
                    <h3 className='modal__header__title'>Pick Ticket Info</h3>
                </div>
                <div className="modal__body">
                    {
                        items && items.some(x => x.isExclude === true) &&
                        <PickTicketInfoTable
                            items={items.filter(x => x.isExclude === true)}
                            isExclude={true}
                            setIncludeInPickTicket={setIncludeInPickTicket}
                            disabledSendOrder={disabledSendOrder}
                        />
                    }
                    {
                        groupedSentSeparatelyItems && groupedSentSeparatelyItems.some(x => x.itemId) &&
                        <PickTicketInfoSentSeparatelyTable
                            gropedItems={groupedSentSeparatelyItems}
                            items={sentSeparatelyItems}
                        />
                    }
                    {
                        items && items.some(x => x.isExclude === false) &&
                        <PickTicketInfoTable
                            items={items.filter(x => x.isExclude === false)}
                            isExclude={false}
                            disabledSendOrder={disabledSendOrder}
                        />
                    }
                    {
                        disabled && <p>No data to display.</p>
                    }
                </div>
                <div className='modal__footer is-right'>
                    {items && items.some(x => x.isExclude === true) &&
                        <BaasicButton
                            className='btn btn--med btn--primary'
                            label="Refresh Pick Ticket"
                            onClick={async () => await refreshPickTicketNewFlow()}
                            disabled={disabled || disabledSendOrder || isLoading || refreshPickTicket == null || !isChanged}
                        />}
                    {isOrderSent && <BaasicButton
                        className='btn btn--med btn--primary'
                        label="Email biller"
                        onClick={() => sendInfoEmail()}
                        rotate icon={
                            isLoading
                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                : 'u-display--none'
                        }
                        disabled={disabled || isLoading}
                    />}
                </div>
            </Content>
        </div>
    )
}

PickTicketInfoModalTemplate.propTypes = {
    pickTicketInfoModalStore: PropTypes.object
};

const PickTicketInfoTable = observer(({ items, isExclude, setIncludeInPickTicket, disabledSendOrder }) => {
    return (
        <div className="u-mar--top--lrg">
            {
                isExclude ?
                    <div>
                        <div className="type--wgt--bold u-mar--bottom--tny">Items not Included Based on Scheduled Run Date</div>
                        <div className="type--sml type--color--opaque u-mar--bottom--sml">Only applicable to g-tubes, trach tubes, and protein supplements</div>
                    </div>
                    :
                    <div className="type--wgt--bold u-mar--bottom--sml">Items with Wrong Run Date (included on PT; fix run date)</div>

            }
            <table className="table--preview">
                <thead>
                    <tr>
                        {isExclude ? <th width="7%" className="type--left">Include</th> : null}
                        <th width="*" className="type--left">Patient Name</th>
                        <th width="35%" className="type--left">Item Name</th>
                        <th width="20%" className="type--left">Item Id</th>
                        <th width="20%" className="type--left">Next Run Date</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => {
                        return (
                            <tr key={item.id}>
                                {isExclude ? <td className="type--center"><BasicCheckbox className='input--check input--check--no-label' id={item.id} checked={item.includeInPickTicket} disabled={disabledSendOrder} onChange={() => setIncludeInPickTicket(item)}/></td> : null}
                                <td>{item.patientName}</td>
                                <td>{item.itemName}</td>
                                <td>{item.itemId}</td>
                                <td className="type--right"> {item.nextRunDate && toDate(item.nextRunDate)} </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
});

PickTicketInfoTable.propTypes = {
    items: PropTypes.object,
    isExclude: PropTypes.bool,
    disabledSendOrder: PropTypes.bool
};

const PickTicketInfoSentSeparatelyTable = observer(({ gropedItems, items }) => {
    return (
        <React.Fragment>
            <div className="u-mar--top--lrg">
                <div className="type--wgt--bold u-mar--bottom--sml">The following items were sent separately and were therefore not included in the pick ticket</div>
                <table className="table--preview">
                    <thead>
                        <tr>
                            <th width="50%" className="type--left">Item Name</th>
                            <th width="30%" className="type--left">Item Id</th>
                            <th width="20%" className="type--left">SS QTY</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gropedItems.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td>{item.itemName}</td>
                                    <td>{item.itemId}</td>
                                    <td>{item.sendSeparatelyQty}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {items.some(x => x.isReferenceBillable) &&
                <div className="u-mar--top--lrg">
                    <div className="type--wgt--bold u-mar--bottom--sml">SS were done on the following covered patients; be sure to update confirming status to cutback.</div>
                    <table className="table--preview">
                        <thead>
                            <tr>
                                <th width="25%" className="type--left">Patient Name</th>
                                <th width="35%" className="type--left">Item Name</th>
                                <th width="20%" className="type--left">Item Id</th>
                                <th width="10%" className="type--left">SO QTY</th>
                                <th width="10%" className="type--left">SS QTY</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.filter(x=>x.isReferenceBillable).map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>{item.patientName}</td>
                                        <td>{item.itemName}</td>
                                        <td>{item.itemId}</td>
                                        <td>{item.totalQty}</td>
                                        <td>{item.sendSeparatelyQty}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </React.Fragment>
    );
});

PickTicketInfoSentSeparatelyTable.propTypes = {
    gropedItems: PropTypes.object,
    items: PropTypes.object,
};

export default defaultTemplate(PickTicketInfoModalTemplate);
